import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import React from 'react'

interface UseCircleProgressAnimationProps {
    ref: React.RefObject<SVGCircleElement | null>
    duration: number
    isRunning: boolean
    onComplete?: () => void
}

const useCircleProgressAnimation = ({ ref, duration, isRunning, onComplete }: UseCircleProgressAnimationProps) => {
    useGSAP(() => {
        const circle = ref.current

        if (!circle || !isRunning) return

        let circleLength = 0

        try {
            circleLength = circle.getTotalLength()
        } catch (err) {
            console.log(err)
            circle.style.display = 'none'

            return
        }

        gsap.killTweensOf(circle)

        gsap.fromTo(
            circle,
            { strokeDasharray: circleLength, strokeDashoffset: 0 },
            {
                strokeDashoffset: -circleLength,
                duration,
                ease: 'linear',
                onStart: () => {
                    gsap.set(circle, { strokeDashoffset: 0, opacity: 1 })
                },
                onComplete: () => {
                    gsap.set(circle, { strokeDashoffset: 0, opacity: 0 })

                    onComplete?.()
                },
            }
        )
    }, [isRunning])
}

export default useCircleProgressAnimation
